import type React from 'react';
import type { ArticleCarouselComponent } from 'api/types';
import BaseArticleStep from '../BaseArticleStep/BaseArticleStep';

interface ArticleCarouselProps {
  isLastStep: boolean;
  stepIndex: number;
  /**  Component's data */
  widgetComponent: ArticleCarouselComponent;
}

const ArticleCarousel: React.FC<
  React.PropsWithChildren<ArticleCarouselProps>
> = props => {
  return <BaseArticleStep {...props} isAgathaMessageVisible />;
};

export default ArticleCarousel;
